import React from "react";

import { useGetAllShipmentOrders } from "../../hooks";
import { HubTableTemplate } from "../../components";

import ShipmentOrdersContextMenu from "./ShipmentOrdersContextMenu";
import ShipmentOrdersEmpty from "./ShipmentOrdersEmpty";

import { getItems, getKeys } from "./helper";
// import { ShipmentPackagesTableContainer } from "../ShipmentPackagesTable";

export const ShipmentOrdersTable = ({
  locationId = 1,
  returning = false,
  orderId,
  customerId,
  enabled = true,
}) => {
  const { data, isLoading } = useGetAllShipmentOrders({
    locationId,
    returning,
    customerId,
    orderId,
    enabled,
  });

  const items = getItems(returning);
  const keys = getKeys(returning);

  const headerProps = {
    items,
    includeChevron: true,
    includeEnd: true,
  };
  const bodyProps = {
    items: data?.rows,
    includeChevron: true,
    keys,
    ContextMenu: ShipmentOrdersContextMenu,
    // RenderElement: ShipmentPackagesTableContainer
  };
  const props = {
    headerProps,
    bodyProps,
    meta: { ...data?.meta },
    isLoading,
  };

  const isEmpty = !(isLoading || data?.rows?.length);
  return isEmpty ? (
    <ShipmentOrdersEmpty />
  ) : (
    <HubTableTemplate id="ShipmentOrders" {...props} />
  );
};

export default ShipmentOrdersTable;
